import { SET_DASHBOARD_AUDITS, SET_DASHBOARD_ISSUES, SET_DASHBOARD_ALERTS } from "../actions/Dashboard"; 
import produce from "immer"; 

const INITIAL_STATE = { 
    audits: [], 
    issues: [], 
    alerts: [], 
}; 
export const dashboardReducer = produce((draft, action) => 
    { switch (action.type) { 
        case SET_DASHBOARD_AUDITS: draft.audits = action.payload; break; 
        case SET_DASHBOARD_ISSUES: draft.issues = action.payload; break; 
        case SET_DASHBOARD_ALERTS: draft.alerts = action.payload; break; 
        default: break; 
    } }, INITIAL_STATE);